import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Row, Col, Badge, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import { LICHHOCLIENTUC_API, ACCOUNT_API } from '../../../../utils/apiUrl';
import { Put, Get } from '../../../../utils/httpProvider';

const EditScheduleLienTucModal = ({
    show,
    onHide,
    item,
    lopDetail,
    donViList = [],
    onSuccess
}) => {
    const [selectedDonViList, setSelectedDonViList] = useState([]);
    const [donViKeyword, setDonViKeyword] = useState('');
    const [showDonViDropdown, setShowDonViDropdown] = useState(false);
    const [ngayBatDau, setNgayBatDau] = useState('');
    const [ngayKetThuc, setNgayKetThuc] = useState('');
    const [trinhDo, setTrinhDo] = useState('');
    const [ghiChu, setGhiChu] = useState('');
    const [trangThai, setTrangThai] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Multi-select live search hospital-wide tutors
    const [selectedTutors, setSelectedTutors] = useState([]);
    const [tutorKeyword, setTutorKeyword] = useState('');
    const [tutorResults, setTutorResults] = useState([]);
    const [isSearchingTutor, setIsSearchingTutor] = useState(false);
    const [showTutorDropdown, setShowTutorDropdown] = useState(false);
    const searchTimeoutRef = useRef(null);

    const handleSelectDonVi = (dv) => {
        const id = dv.id || dv.Id || '00000000-0000-0000-0000-000000000000';
        const ten = dv.tenDonVi || dv.TenDonVi || '';
        if (!selectedDonViList.some(d => (d.id && d.id !== '00000000-0000-0000-0000-000000000000' && d.id === id) || d.tenDonVi.toLowerCase() === ten.toLowerCase())) {
            setSelectedDonViList(prev => [...prev, { id, tenDonVi: ten }]);
        }
        setDonViKeyword('');
        setShowDonViDropdown(false);
    };

    const handleRemoveDonVi = (targetName) => {
        setSelectedDonViList(prev => prev.filter(d => d.tenDonVi !== targetName && d.id !== targetName));
    };

    const handleAddCustomDonVi = () => {
        if (donViKeyword.trim()) {
            const customName = donViKeyword.trim();
            if (!selectedDonViList.some(d => d.tenDonVi.toLowerCase() === customName.toLowerCase())) {
                setSelectedDonViList(prev => [...prev, { id: '00000000-0000-0000-0000-000000000000', tenDonVi: customName }]);
            }
            setDonViKeyword('');
            setShowDonViDropdown(false);
        }
    };

    const getTutorFullName = (itemObj) => {
        const fName = itemObj.firstName || itemObj.accountAuthInfo?.firstName || '';
        const mName = itemObj.middleName || itemObj.accountAuthInfo?.middleName || '';
        const lName = itemObj.lastName || itemObj.accountAuthInfo?.lastName || '';
        let name = `${lName} ${mName} ${fName}`.replace(/\s+/g, ' ').trim();
        if (!name) name = itemObj.fullName || itemObj.fullname || itemObj.userName || 'Chưa rõ tên';
        return name;
    };

    useEffect(() => {
        if (item) {
            if (item.donVi) {
                const parts = item.donVi.split(',').map(s => s.trim()).filter(Boolean);
                const list = parts.map(name => {
                    const matched = donViList.find(d => (d.tenDonVi || d.TenDonVi || '').toLowerCase() === name.toLowerCase());
                    return {
                        id: matched ? (matched.id || matched.Id) : (item.donViId || '00000000-0000-0000-0000-000000000000'),
                        tenDonVi: name
                    };
                });
                setSelectedDonViList(list);
            } else if (item.donViId) {
                const matched = donViList.find(d => (d.id || d.Id) === item.donViId);
                if (matched) {
                    setSelectedDonViList([{ id: matched.id || matched.Id, tenDonVi: matched.tenDonVi || matched.TenDonVi }]);
                } else {
                    setSelectedDonViList([]);
                }
            } else {
                setSelectedDonViList([]);
            }

            setNgayBatDau(item.ngayBatDau ? moment(item.ngayBatDau).format('YYYY-MM-DD') : '');
            setNgayKetThuc(item.ngayKetThuc ? moment(item.ngayKetThuc).format('YYYY-MM-DD') : '');
            setTrinhDo(item.trinhDo || '');
            setGhiChu(item.ghiChu || '');
            setTrangThai(item.trangThai ?? 1);

            const gvs = item.giangViens?.$values || item.giangViens || [];
            if (gvs.length > 0) {
                setSelectedTutors(gvs.map(g => ({
                    id: g.giangVienLienTucId || g.id,
                    fullName: g.giangVienTen || 'Giảng viên',
                    identityCard: ''
                })));
            } else if (item.giangVienId || item.giangVienTen) {
                setSelectedTutors([{
                    id: item.giangVienId,
                    fullName: item.giangVienTen || 'Giảng viên',
                    identityCard: ''
                }]);
            } else {
                setSelectedTutors([]);
            }
        }
    }, [item]);

    const handleTutorSearchChange = (e) => {
        const val = e.target.value;
        setTutorKeyword(val);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        if (!val || val.trim().length < 2) {
            setTutorResults([]);
            setShowTutorDropdown(false);
            setIsSearchingTutor(false);
            return;
        }

        setIsSearchingTutor(true);
        setShowTutorDropdown(true);

        searchTimeoutRef.current = setTimeout(async () => {
            try {
                const response = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT_NOT_MENU, null, {
                    Keyword: val.trim(),
                    PageIndex: 1,
                    PageSize: 15
                });
                const resData = response?.data || response;
                const items = resData?.data || resData?.$values || (Array.isArray(resData) ? resData : []);
                setTutorResults(items);
            } catch (err) {
                console.error("Lỗi tìm kiếm cán bộ/giảng viên:", err);
                setTutorResults([]);
            } finally {
                setIsSearchingTutor(false);
            }
        }, 300);
    };

    const handleSelectTutor = (tItem) => {
        const id = tItem.id || tItem.accountId;
        if (selectedTutors.some(t => t.id === id)) {
            toast.info('Giảng viên này đã được chọn trong danh sách.');
            setTutorKeyword('');
            setShowTutorDropdown(false);
            return;
        }

        const fullName = getTutorFullName(tItem);
        const cccd = tItem.identityCardNumber || tItem.identityCard || tItem.accountAuthInfo?.identityCardNumber || tItem.accountAuthInfo?.identityCard || '';

        setSelectedTutors(prev => [
            ...prev,
            {
                id: id,
                fullName: fullName,
                identityCard: cccd,
                donVi: tItem.donVi || tItem.accountAuthInfo?.donVi || ''
            }
        ]);

        setTutorKeyword('');
        setTutorResults([]);
        setShowTutorDropdown(false);
    };

    const handleRemoveTutor = (tutorId) => {
        setSelectedTutors(prev => prev.filter(t => t.id !== tutorId));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!item?.id) return;
        if (!ngayBatDau) {
            toast.warning('Vui lòng chọn ngày bắt đầu.');
            return;
        }

        const primaryDonViId = lopDetail?.khoaDeXuatId || item?.donViId || '00000000-0000-0000-0000-000000000000';
        const donViText = lopDetail?.khoaDeXuatTen || item?.donVi || 'Khoa chuyên môn';

        const payload = {
            donViId: primaryDonViId,
            donVi: donViText,
            donVis: [{
                id: primaryDonViId,
                tenDonVi: donViText
            }],
            giangVienLienTucIds: selectedTutors.map(t => t.id),
            giangViens: selectedTutors.map((t) => ({
                id: t.id,
                ten: t.fullName,
                laGiangVienChinh: false
            })),
            giangVienTen: selectedTutors.map(t => t.fullName).join(', '),
            ngayBatDau: ngayBatDau,
            ngayKetThuc: ngayKetThuc || null,
            trinhDo: trinhDo,
            ghiChu: ghiChu,
            trangThai: Number(trangThai)
        };

        try {
            setIsSubmitting(true);
            const res = await Put(LICHHOCLIENTUC_API.UPDATE_ITEM, item.id, payload);
            if (res) {
                toast.success('Cập nhật lịch học thành công.');
                if (onSuccess) onSuccess();
                onHide();
            }
        } catch (err) {
            toast.error(err?.message || 'Không thể cập nhật lịch học.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="font-weight-bold text-primary">
                    <i className="fas fa-edit mr-2"></i>
                    Chỉnh Sửa Lịch Học
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body className="py-3">
                    <div className="bg-light p-2 rounded mb-3 border">
                        <div className="text-muted small">Học viên:</div>
                        <div className="font-weight-bold text-dark">{item?.hocVienTen || 'Chưa rõ tên'}</div>
                    </div>

                    {/* KHOA PHỤ TRÁCH ĐÀO TẠO (CỐ ĐỊNH THEO LỚP) */}
                    <div className="p-3 rounded mb-3 border shadow-xs" style={{ backgroundColor: '#f0f9ff', borderColor: '#bae6fd' }}>
                        <div className="d-flex align-items-center">
                            <div className="p-2 rounded bg-white mr-3 shadow-xs text-primary">
                                <i className="fas fa-hospital-alt fa-lg"></i>
                            </div>
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Khoa phụ trách đào tạo</div>
                                <div className="font-weight-bold text-dark" style={{ fontSize: '15px' }}>
                                    {lopDetail?.khoaDeXuatTen || item?.donVi || "Khoa chuyên môn"}
                                </div>
                                <small className="text-secondary">Cố định theo lớp đào tạo liên tục</small>
                            </div>
                        </div>
                    </div>

                    {/* CHỌN NHIỀU GIẢNG VIÊN TOÀN VIỆN */}
                    <Form.Group className="mb-3 position-relative">
                        <Form.Label className="font-weight-bold small text-dark d-flex justify-content-between align-items-center mb-1">
                            <span>
                                <i className="fas fa-user-md text-primary mr-1"></i>
                                Giảng viên phụ trách (Toàn bệnh viện)
                            </span>
                            <Badge variant={selectedTutors.length > 0 ? "success" : "secondary"}>
                                Đã chọn {selectedTutors.length}
                            </Badge>
                        </Form.Label>

                        {/* Danh sách giảng viên dạng thẻ badge */}
                        {selectedTutors.length > 0 && (
                            <div className="d-flex flex-wrap mb-2 p-2 rounded bg-light border" style={{ gap: '6px' }}>
                                {selectedTutors.map((t, idx) => (
                                    <Badge
                                        key={t.id || idx}
                                        variant="primary"
                                        className="p-2 d-inline-flex align-items-center shadow-xs"
                                        style={{ fontSize: '12px', fontWeight: '500' }}
                                    >
                                        <i className="fas fa-chalkboard-teacher mr-1"></i>
                                        {t.fullName}
                                        <i
                                            className="fas fa-times-circle ml-2"
                                            style={{ cursor: 'pointer', fontSize: '13px' }}
                                            onClick={() => handleRemoveTutor(t.id)}
                                            title="Bỏ chọn"
                                        ></i>
                                    </Badge>
                                ))}
                            </div>
                        )}

                        {/* Ô tìm kiếm để thêm tiếp */}
                        <div className="position-relative">
                            <Form.Control
                                type="text"
                                size="sm"
                                placeholder="Gõ tên hoặc CCCD để thêm giảng viên toàn viện..."
                                value={tutorKeyword}
                                onChange={handleTutorSearchChange}
                                autoComplete="off"
                            />
                            {isSearchingTutor && (
                                <div className="position-absolute" style={{ right: 10, top: 7 }}>
                                    <Spinner animation="border" size="sm" variant="primary" />
                                </div>
                            )}

                            {showTutorDropdown && (
                                <div
                                    className="position-absolute w-100 bg-white border rounded shadow-lg mt-1"
                                    style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1050 }}
                                >
                                    {tutorResults.length === 0 ? (
                                        <div className="p-3 text-center text-muted small">
                                            {isSearchingTutor ? 'Đang tra cứu hệ thống...' : 'Không tìm thấy cán bộ / giảng viên nào khớp từ khóa'}
                                        </div>
                                    ) : (
                                        tutorResults.map((tItem, idx) => {
                                            const name = getTutorFullName(tItem);
                                            const cccd = tItem.identityCardNumber || tItem.identityCard || tItem.accountAuthInfo?.identityCardNumber || tItem.accountAuthInfo?.identityCard || '';
                                            const uName = tItem.userName || tItem.username || '';
                                            const isAlreadyChosen = selectedTutors.some(t => t.id === (tItem.id || tItem.accountId));

                                            return (
                                                <div
                                                    key={tItem.id || idx}
                                                    className={`p-2 border-bottom d-flex align-items-center justify-content-between ${isAlreadyChosen ? 'bg-light text-muted' : ''}`}
                                                    style={{ cursor: isAlreadyChosen ? 'default' : 'pointer' }}
                                                    onClick={() => !isAlreadyChosen && handleSelectTutor(tItem)}
                                                    onMouseEnter={(e) => { if (!isAlreadyChosen) e.currentTarget.style.backgroundColor = '#f0f4f8'; }}
                                                    onMouseLeave={(e) => { if (!isAlreadyChosen) e.currentTarget.style.backgroundColor = '#fff'; }}
                                                >
                                                    <div>
                                                        <div className="font-weight-bold small">{name}</div>
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>
                                                            {cccd ? `CCCD: ${cccd}` : (uName ? `Username: ${uName}` : '')}
                                                        </div>
                                                    </div>
                                                    {isAlreadyChosen ? (
                                                        <span className="badge badge-secondary small">Đã thêm</span>
                                                    ) : (
                                                        <Button variant="outline-primary" size="sm" className="py-0 px-2 small">
                                                            + Thêm
                                                        </Button>
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                        </div>
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold small text-dark">
                                    Từ ngày <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="date"
                                    size="sm"
                                    value={ngayBatDau}
                                    onChange={(e) => setNgayBatDau(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold small text-dark">
                                    Đến ngày
                                </Form.Label>
                                <Form.Control
                                    type="date"
                                    size="sm"
                                    value={ngayKetThuc}
                                    onChange={(e) => setNgayKetThuc(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-dark">
                            Nội dung đào tạo / Trình độ
                        </Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="VD: Tuần 1 - Lâm sàng..."
                            value={trinhDo}
                            onChange={(e) => setTrinhDo(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-dark">
                            Trạng thái
                        </Form.Label>
                        <Form.Control
                            as="select"
                            size="sm"
                            value={trangThai}
                            onChange={(e) => setTrangThai(e.target.value)}
                        >
                            <option value={1}>Đã xác nhận</option>
                            <option value={0}>Nháp</option>
                            <option value={2}>Cảnh báo</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label className="font-weight-bold small text-dark">
                            Ghi chú
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            size="sm"
                            value={ghiChu}
                            onChange={(e) => setGhiChu(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="bg-light py-2">
                    <Button variant="secondary" size="sm" onClick={onHide} disabled={isSubmitting}>
                        Hủy
                    </Button>
                    <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Đang lưu...' : 'Lưu Thay Đổi'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditScheduleLienTucModal;
